import { useState } from 'react';
import toast from 'react-hot-toast';
import { X } from 'lucide-react';
import styles from './RevealHiddenModal.module.css';

export default function RevealHiddenModal({ onReveal, onClose }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;

    setLoading(true);
    try {
      const revealed = await onReveal(password.trim());
      if (revealed.length > 0) {
        onClose();
      } else {
        toast.error('No channels match that password');
      }
    } catch {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div className={styles.dialog}>
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close"><X size={16} /></button>
        <h2 className={styles.heading}>Reveal hidden channels</h2>
        <p className={styles.description}>
          Enter password to reveal matching hidden channels.
        </p>
        <form onSubmit={handleSubmit} className={styles.form}>
          <label className={styles.label}>
            Password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className={styles.input}
              placeholder="Enter password"
              autoFocus
            />
          </label>
          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>Cancel</button>
            <button type="submit" className={styles.submitBtn} disabled={loading || !password.trim()}>
              {loading ? 'Checking...' : 'Reveal'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
